export const SET_EN = 'SET_EN';
export const SET_ES = 'SET_ES';
